import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { withTheme } from "@material-ui/core/styles";

import mapboxgl from "mapbox-gl";

import { Button } from "@material-ui/core";
import { FaTree } from "react-icons/fa";
import { GiAxeInStump } from "react-icons/gi";

import DonateeInfo from "../Panels/DonateeInfo/DonateeInfo";

import { addTheirDonationToDonations } from "../../Functions/functions";
import * as mapFunctions from "../../Functions/MapUseffects";

mapboxgl.accessToken =
  "pk.eyJ1IjoibGFuZ3VhZ2VtYXRlIiwiYSI6ImNraWV1eDBxazF3anoydHJzZnl4OG42dm8ifQ.jreROrH55pUXupL_gPTQjw";

const WidthOfMapSection = styled.div`
  width: 65vw;
  padding: 0 25px;
  margin-bottom: 25px;
`;
const StyledMap = styled(WidthOfMapSection)`
  height: 60vh;
`;
const Row = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
`;
const MapOptions = styled(WidthOfMapSection)`
  background-color: ${(props) => props.theme.palette.primary.main};
  color: ${(props) => props.theme.palette.yellow.light};

  font-size: 20px;
  font-weight: 600;

  padding: 1vh 0;

  border-radius: ${(props) => props.theme.border.radius};
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;

  padding: 2vh 0;
`;
const Panel = styled(MapOptions)`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  border-radius: ${(props) => props.theme.border.radius};
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;

  box-shadow: ${(props) => props.theme.border.shadow + props.theme.palette.primary.main};
`;

const Map = (props) => {
  const mapContainerRef = useRef(null);
  //map controls
  const [map, setMap] = useState(null);
  const [zoom, setZoom] = useState(15.86);
  const [lat, setLat] = useState(51.4936);
  const [lng, setLng] = useState(0.0157);

  const MAIN_FOREST_SOURCE = "main_forest_source";
  const MAIN_FOREST_LAYER = "main_forest_layer";
  const [mapEvent, setMapEvent] = useState(null);
  const [donateeInfo, setDonateeInfo] = useState({
    id: null,
    name: null,
    amount: null,
  });

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [lng, lat],
      zoom: zoom,
    });

    map.on("load", () => {
      mapFunctions.addMapControls(map);
      setMap(map);
    });
    map.on("move", () => {
      mapFunctions.updateMapState(map, setLat, setLng, setZoom);
    });
  }, []);

  useEffect(() => {
    if (map) {
      mapFunctions.updateForestLocationInState(
        map.getCenter().lng,
        map.getCenter().lat,
        props.setForestLng,
        props.setForestLat
      );
    }
  }, [map]);

  useEffect(() => {
    if (map) {
      const allForestDonations = addTheirDonationToDonations(props.forestDonations, props.payment);
      mapFunctions.addForestDonations(map, allForestDonations, props.forestLng, props.forestLat);
    }
  }, [props.forestLat, props.forestLng, props.payment, props.forestDonations]);

  // Add action listeners for hover functionality
  useEffect(() => {
    if (map) {
      map.on("mousemove", MAIN_FOREST_LAYER, (e) => setMapEvent(e.features));

      map.on("click", (e) => {
        if (
          map
            .queryRenderedFeatures(e.point)
            .filter((feature) => feature.source === MAIN_FOREST_SOURCE).length === 0
        ) {
          mapFunctions.updateForestLocationInState(
            e.lngLat.lng,
            e.lngLat.lat,
            props.setForestLng,
            props.setForestLat
          );
        } else {
          setMapEvent(e.features);
        }
      });

      map.on("mouseleave", MAIN_FOREST_LAYER, (e) => setMapEvent("leaveSegment"));
    }
  }, [map]);
  //React to mapevents for hover functionality
  useEffect(() => {
    if (mapEvent === "leaveSegment") {
      mapFunctions.removeFillOnLeave(map, mapEvent, donateeInfo, setDonateeInfo);
    } else {
      mapFunctions.addFillOnHover(map, mapEvent, donateeInfo, setDonateeInfo);
    }
  }, [mapEvent, donateeInfo]);

  return (
    <Row>
      <StyledMap ref={mapContainerRef} />
      <Panel>
        <DonateeInfo donateeInfo={donateeInfo} forestDonations={props.forestDonations} />
      </Panel>
    </Row>
  );
};

export default withTheme(Map);
